import React, { useState, useEffect, useCallback } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import PersistenciaDashboard from './persistencia/PersistenciaDashboard';
import PersistenciaConfigAcciones from './persistencia/PersistenciaConfigAcciones';
import PersistenciaGrupoControl from './persistencia/PersistenciaGrupoControl';
import PersistenciaListas from './persistencia/PersistenciaListas';
import PersistenciaMedicion from './persistencia/PersistenciaMedicion';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PersistenciaEngine = ({ token }) => {
  const [instances, setInstances] = useState([]);

  const loadInstances = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/api/persistencia/instances`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const d = await response.json();
      setInstances(d.instances || []);
    } catch (error) {
      console.error('Error cargando instancias de Persistencia:', error);
    }
  }, [token]);

  useEffect(() => { loadInstances(); }, [loadInstances]);

  return (
    <div className="space-y-6" data-testid="persistencia-engine-page">
      <div className="bg-white p-4 rounded-lg border">
        <h2 className="text-2xl font-bold text-gray-900">Motor de Persistencia</h2>
        <p className="text-gray-500 mt-1">
          Etapa 1: dashboard, config de acciones y grupo de control - 100% en la app, sin escribir en HubSpot ni enviar nada todavía.
        </p>
      </div>

      <Tabs defaultValue="dashboard" className="w-full">
        <TabsList>
          <TabsTrigger value="dashboard" data-testid="tab-persistencia-dashboard">Dashboard</TabsTrigger>
          <TabsTrigger value="config" data-testid="tab-persistencia-config">Config de Acciones</TabsTrigger>
          <TabsTrigger value="control" data-testid="tab-persistencia-control">Grupo de Control</TabsTrigger>
          <TabsTrigger value="listas" data-testid="tab-persistencia-listas">Listas</TabsTrigger>
          <TabsTrigger value="medicion" data-testid="tab-persistencia-medicion">Medición</TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard" className="mt-4">
          <PersistenciaDashboard token={token} />
        </TabsContent>
        <TabsContent value="config" className="mt-4">
          <PersistenciaConfigAcciones token={token} instances={instances} />
        </TabsContent>
        <TabsContent value="control" className="mt-4">
          <PersistenciaGrupoControl token={token} instances={instances} />
        </TabsContent>
        <TabsContent value="listas" className="mt-4">
          <PersistenciaListas token={token} instances={instances} />
        </TabsContent>
        <TabsContent value="medicion" className="mt-4">
          <PersistenciaMedicion token={token} instances={instances} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PersistenciaEngine;
